import React, {useEffect, useState} from 'react'
import PropTypes from 'prop-types'
import {makeStyles} from '@material-ui/styles'
import {Checkboxes, Radios} from "mui-rff"
import FormLabel from "../../FormLabel"

const useStyles = makeStyles(() => ({
  container: {
    flexDirection: 'row'
  }
}))

const FormCheckboxes = ({field, title, options, isFilter, required}) => {
  const classes = useStyles()

  const [formattedOptions, setOptions] = useState([])

  // Format options
  useEffect(() => {
    let formattedOptions = []
    options.map(option => {
      formattedOptions.push({
        label: option.name,
        value: option.id
      })
    })

    setOptions(formattedOptions)
  }, [])

  return (
    <>
      <FormLabel title={title} isFilter={isFilter}/>
      <Checkboxes
        required={required}
        label={title}
        name={field}
        data={formattedOptions}
        formGroupProps={{className: classes.container}}
      />
    </>
  )
}

FormCheckboxes.propTypes = {
  field: PropTypes.string,
  type: PropTypes.string,
  title: PropTypes.any,
}

export default FormCheckboxes
